import { bindSwiperAutoplayToViewport } from "../utils/bind-swiper-autoplay-to-viewport.js";

export function initThreeColCardsSlider() {
  if (typeof Swiper === "undefined") {
    return;
  }

  const sectionNodes = document.querySelectorAll(".js-three-col-cards");
  if (!sectionNodes.length) {
    return;
  }

  const mobileQuery = window.matchMedia("(max-width: 768px)");

  const controllers = Array.from(sectionNodes).map((sectionEl) => {
    const sliderEl = sectionEl.querySelector(".three-col-cards__slider");
    const btnPrev = sectionEl.querySelector(".three-col-cards__nav-btn--prev");
    const btnNext = sectionEl.querySelector(".three-col-cards__nav-btn--next");

    let swiperInstance = null;
    let releaseViewport = () => { };

    const initSwiper = () => {
      if (!sliderEl || swiperInstance) {
        return;
      }

      const slideCountForLoop = sliderEl.querySelectorAll(".swiper-slide").length;
      const useLoop = slideCountForLoop > 2;

      swiperInstance = new Swiper(sliderEl, {
        slidesPerView: 1.08,
        spaceBetween: 10,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
        loop: useLoop,
        breakpoints: {
          480: {
            slidesPerView: 1.08,
            spaceBetween: 16,
          },
        },
      });

      releaseViewport();
      releaseViewport = bindSwiperAutoplayToViewport(swiperInstance);
    };

    const destroySwiper = () => {
      if (!swiperInstance) {
        return;
      }
      releaseViewport();
      releaseViewport = () => { };
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    return { initSwiper, destroySwiper };
  });

  const syncViewports = () => {
    controllers.forEach((c) => {
      if (mobileQuery.matches) {
        c.initSwiper();
      } else {
        c.destroySwiper();
      }
    });
  };

  syncViewports();

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", syncViewports);
  } else {
    mobileQuery.addListener(syncViewports);
  }
}
